module.exports = "/images/location.svg?ed1b254d402993a2c6bda17b217dcc5e";